// Reads the `type` claim ("Admin"/"Vendor"/"Subvendor") directly off the
// stored JWT instead of a separate, hand-maintained role-tag string in
// localStorage ("tokenAdmin"==="Ankit", "tokenVender"==="Raitwar",
// "tokenSubVender"==="Rohit" -- see JwtLogin.jsx/AuthGuard.jsx's git
// history). The JWT already carries the real role (admin.controller.js's
// login signs {id, userName, type}), so duplicating it into a second piece
// of state that can drift out of sync from the actual token serves no
// purpose. Not a security check -- the signature isn't verified
// client-side, same trust level as the plain-string tag it replaces; real
// authorization still happens server-side via verifyVendorOrAdmin.
export function getRoleFromToken(token) {
  if (!token) return null;
  try {
    const payload = token.split(".")[1];
    const decoded = JSON.parse(atob(payload.replace(/-/g, "+").replace(/_/g, "/")));
    return decoded?.type || null;
  } catch {
    return null;
  }
}
